import styled from '@emotion/styled';

export const Layout = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const RingWrapper = styled.div`
  position: relative;
  flex-shrink: 0;
  width: 112px;
  height: 112px;
`;

export const RingCenter = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  pointer-events: none;
`;

export const CountList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
  min-width: 0;
`;

export const CountRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
`;

export const LegendColor = styled.div`
  width: 6px;
  height: 6px;
  min-width: 6px;
  border-radius: 50%;

  &.shading {
    border: 1px solid ${({ theme }) => theme.colors.WhiteGray};
  }

  &.primary {
    background-color: ${({ theme }) => theme.colors.DarkYellow};
  }

  &.secondary {
    background-color: ${({ theme }) => theme.colors.WhiteGray20};
  }
`;
